import { useState } from 'react';

// won't work without https

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>; // Return success

interface CopyToClipboard {
  copiedText: CopiedValue;
  copy: CopyFn;
}

export const useCopyToClipboard = (): CopyToClipboard => {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      console.warn('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  };

  return { copiedText, copy };
};

export default useCopyToClipboard;
